import React from "react";
import { Slide, Heading, Text } from "spectacle";

export default [
  <Slide>
    <Heading size={1} fit caps lineHeight={1} textColor="header">
      Kunst in wiskunde
    </Heading>
    <Text margin="10px 0 0" textColor="tertiary" size={1} fit bold>
    Het vinden van nulpunten
    </Text>
  </Slide>
];
